import {
  CreateSaleInfoRequest,
  SaleInfoResponse,
} from "../../../infrastructure/model/SaleInfoModel";
import { SaleInfoService } from "../../../infrastructure/services/SaleInfoService";
import { PageResponse } from "../../constants/AppTypes";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const getAllSaleInfoUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    page: number;
    limit: number;
    is_sale_order?: boolean;
    is_active?: boolean;
  }
): Promise<PageResponse<SaleInfoResponse[]>> => {
  const { page, limit, is_sale_order, is_active, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: PageResponse<SaleInfoResponse[]> = {
      total: 0,
      data: [],
    };
    const res = await SaleInfoService.getAllSaleInfo(page, limit, is_sale_order, is_active);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = {
          data: res.data.data,
          total: res.data.total,
        };
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const activeSaleUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { saleId: number; status: boolean }
): Promise<boolean> => {
  const { saleId, status, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await SaleInfoService.enableActive(saleId, status);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res?.message);
      },
      onSuccess() {
        showSuccess?.("Kích hoạt CTKM thành công");
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteSaleUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { saleId: number }
): Promise<boolean> => {
  const { saleId, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await SaleInfoService.deleteSale(saleId);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res?.message);
      },
      onSuccess() {
        showSuccess?.("Xóa CTKM thành công");
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createSaleUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { request: CreateSaleInfoRequest; thumbnailImage?: File }
): Promise<SaleInfoResponse | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: SaleInfoResponse | undefined = undefined;
    const res = await SaleInfoService.createNewSale(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const updateSaleUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: CreateSaleInfoRequest & { id: number; thumbnailImage?: File };
  }
): Promise<SaleInfoResponse | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: SaleInfoResponse | undefined = undefined;
    const res = await SaleInfoService.updateSale(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
